export default __webpack_public_path__ + "static/media/groom-your-kids.f91db5cd.png";